import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBRYM_VdlP6Lf2oOCvIu0_nCMRnTAcw6Ec",
    authDomain: "encargamelo-f2082.firebaseapp.com",
    projectId: "encargamelo-f2082",
    // storageBucket: "encargamelo-f2082.appspot.com",
    messagingSenderId: "1037636198323",
    appId: "1:1037636198323:web:584a064715c7e6d3b1b5c6",
    measurementId: "G-WH712C3MDB",
    storageBucket: "gs://encargamelo-f2082"
};

const app = initializeApp(firebaseConfig);

export default app;

